import 'Sass/views/library.scss';

window.onload = function () {
    $('#search_scope').on('change', function () {
        document.getElementById('primoQueryTemp').setAttribute('placeholder', $(this).find(':selected').data('placeholder'));
    });

    /**This function builds the search query within the library page for PRIMO site and pass it through url*/
    document.getElementById('go').addEventListener('click', function() {
        document.getElementById('primoQuery').value = 'any,contains,' + document.getElementById('primoQueryTemp').value.replace(/[,]/g, ' ');

        document.forms['searchForm'].submit();
    });

    /* this applies only to the 2018 interface */
    var searchScope = document.getElementById('tab');
    var searchInput = document.getElementById('primoQueryTemp');

    searchScope.addEventListener('change',
        function (e) {
            searchInput.setAttribute('placeholder', e.target.selectedOptions[0].dataset.placeholder);
        });
};

